
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RappiderAlertModule, RappiderButtonModule, RappiderEditFormModule, RappiderListGridModule, RappiderParagraphModule, RappiderSelectModule } from '@rappider/rappider-components';
import { Subscription } from 'rxjs';
import { FILE_LIST_CONFIG, fileListButton, frequencyConfig, salesforceInfoAlertConfig, SELECTED_FILE_LIST_CONFIG } from '../../utils/file-list.configs';
import { Store } from '@ngrx/store';
import { salesforceSelectedObjectsContent } from '../../utils/salesforce-selected-objects.content';
import { RappiderMarkdownViewerModule } from 'libs/components/src/lib/components/markdown-viewer/markdown-viewer.module';
import { GetSalesforceObjectName, ResetSalesforce, SalesforceSelectedObjectsUpdate } from '../../state/salesforce.actions';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'rappider-salesforce-model-list',
  standalone: true,
  imports: [
    CommonModule,
    RappiderEditFormModule,
    RappiderListGridModule,
    RappiderButtonModule,
    RappiderMarkdownViewerModule,
    RappiderSelectModule,
    RappiderParagraphModule,
    RappiderAlertModule,
    FormsModule
  ],
  templateUrl: './salesforce-model-list.component.html',
  styleUrls: ['./salesforce-model-list.component.scss'],
})
export class RappiderSalesforceModelListComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  activeEntityData = [];
  activeEntityDataSelected = [];
  submitButtonLoading = false;
  listGridConfig = FILE_LIST_CONFIG;
  listGridSelectedConfig = SELECTED_FILE_LIST_CONFIG;
  selectedItem = ' ';
  fileListButton = fileListButton;
  salesforceSelectedObjectsContent = salesforceSelectedObjectsContent;
  preSelectedObjects = [];
  salesforceInfoAlertConfig = salesforceInfoAlertConfig;
  frequency = '0 0 * * *';
  frequencyConfig = frequencyConfig;

  constructor(
    private store: Store<any>
  ) { }


  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.store.dispatch(ResetSalesforce());
  }

  ngOnInit() {
    this.subscriptions = [
      this.subscribeToSalesforcePreSelectedModels(),
      this.subscribeToSalesforceModels(),
      this.subscribeToSalesforceSelectedModels()
    ];
  }

  subscribeToSalesforcePreSelectedModels() {
    return this.store.select(state => state.salesforce?.selectedObjects).subscribe((models) => {
      if (models) {
        this.preSelectedObjects = models;
      }
    });
  }

  subscribeToSalesforceModels() {
    return this.store.select(state => state.salesforce?.objects).subscribe((models) => {
      if (models) {
        this.activeEntityData = models.map((model: any) => {
          const object: any = { name: model };

          if (this.preSelectedObjects.includes(model)) {
            object.selected = true;
          }

          return object;
        });
      }
    });
  }

  subscribeToSalesforceSelectedModels() {
    return this.store.select(state => state.salesforce?.selectedObjects).subscribe((objects) => {
      if (objects) {
        this.activeEntityDataSelected = objects?.map(model => ({
          name: model
        }));
      }
    });
  }

  fileListButtonClick() {
    this.store.dispatch(GetSalesforceObjectName({ payload: { objects: this.activeEntityDataSelected?.map(object => object.name), frequency: this.frequency } }));
  }

  onSelectionChange(objects) {
    const selectedObjects = objects?.map(object => object.name);
    this.store.dispatch(SalesforceSelectedObjectsUpdate({ payload: { selectedObjects } }));
  }

  frequencyChange(frequency) {
    this.frequency = frequency;
  }

}
